import { Alert, List } from 'components'
import { IconCheck, IconAlertCircle } from '@tabler/icons-react'
import { useFeatureToggle } from 'hooks'

type StatusType = 'danger' | 'success'

type Props = {
  lesson: any
  hasPermission: boolean
  t: (key: string) => string
}

const LessonAlert: React.FC<Props> = ({ lesson, hasPermission, t }) => {
  const isArc = useFeatureToggle('arc-mosaico-project')
  const status = lesson.sessionMeetingStatus.status as StatusType

  // Arc: hide success ("All good") alert and show simplified pending copy
  if (isArc && status === 'success') return null

  const statusSettings: { [key in StatusType]: { color: string; icon: JSX.Element } } = {
    danger: { color: 'yellow', icon: <IconAlertCircle size='1.4rem' /> },
    success: { color: 'green', icon: <IconCheck size='1.4rem' /> },
  }

  const { color, icon } = statusSettings[status] || statusSettings['danger']

  const title = isArc
    ? t('arc_lesson_alert.pending_title')
    : status !== 'success'
      ? t('generalAlertLesson')
      : t('task_ok')

  const messageText =
    status === 'success'
      ? t('task_ok_message')
      : `${lesson.sessionMeetingStatus.message
          .charAt(0)
          .toUpperCase()}${lesson.sessionMeetingStatus.message.slice(1)}`

  return (
    <Alert icon={icon} title={title} color={color} mb='md' mt='md'>
      <>
        <p>{isArc ? t('arc_lesson_alert.pending_text') : messageText}</p>
        {!isArc && (
          <List mt='xs' spacing='xs' size='sm'>
            {lesson?.sessionMeetingStatus.pendencies?.map((pendency: string, index: number) => (
              <List.Item key={index}>{pendency}</List.Item>
            ))}
          </List>
        )}
      </>
    </Alert>
  )
}

export default LessonAlert
